<nav class="navbar navbar-expand-lg navbar-dark bg-dark">
  <div class="container">
    <a href="/#/principal" class="navbar-brand"><img src="assets/images/lhb.png" alt="homepage" class="light-logo" />
      <img src="assets/images/lhtextow.png" alt="homepage" class="dark-logo" style="margin-top: 10px;"/></a>

    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarNav">

        <ul class="navbar-nav ml-auto">

             <li class="nav-item active" >
                <a class="nav-link" href="/#/login">Iniciar Sesión <span class="sr-only">(current)</span></a>
            </li>
            <li class="nav-item">
              <a class="nav-link" href="/#/principal">Inicio</a>
          </li>

            <li class="nav-item">
              <a class="nav-link" href="/#/enviarmensaje">Contáctanos</a>
          </li>

        </ul>
    </div>
</div>
</nav>

<body>
  <div class="login-box card mt-3">
    <button (click)="regresarPagina()" style="width: 100px; height: 30px; padding: 0px; border: 0px;" class="btn btn-outline-info"><i class="fa fa-hand-o-left" style="margin-right: 8px;"></i>Regresar</button>
    <div class="card-body">
      <form [formGroup]="formularioRegistro" (ngSubmit)="registrarUsuario()" class="form-material" id="loginform"
      action="index.html">
      <h2 class="box-title text-center db"><b>¡Regístrate ahora!</b></h2>
      <div class="text-center db"><img src="assets/images/lh.png" alt="Home" /><br/>
        <img src="assets/images/lhtextob.png" alt="homepage" class="dark-logo" style="margin-top: 10px; margin-bottom: 5px;"/></div>



            <div class="form-group mt-3">
              <label for="nombre">Nombres</label>
              <input formControlName="nombre" name="nombre" class="form-control input-sm" type="text" required minlength="5" maxlength="200">
              <span class="bar"></span>

              <div class="alert-danger" *ngIf="nombre.invalid && (nombre.dirty || nombre.touched)" >
                <div class="container-error-message" *ngIf="nombre.errors.required" >
                  El nombre es requerido
                </div>
                <div class="container-error-message" *ngIf="nombre.errors.minlength">
                  El nombre debe tener mínimo 5 caracteres
                </div>
                <div class="container-error-message" *ngIf="nombre.errors.maxlength">
                  El nombre debe tener máximo 200 caracteres
                </div>
              </div>

        </div>


        <div class="form-group">
          <label for="apellido">Apellidos</label>
          <input formControlName="apellido" name="apellido" class="form-control input-sm" type="text" required minlength="5" maxlength="200"><span
          class="bar"></span>

          <div class="alert-danger" *ngIf="apellido.invalid && (apellido.dirty || apellido.touched)" >
            <div class="container-error-message" *ngIf="apellido.errors.required" >
              El apellido es requerido
            </div>
            <div class="container-error-message" *ngIf="apellido.errors.minlength">
              El apellido debe tener mínimo 5 caracteres
            </div>
            <div class="container-error-message" *ngIf="apellido.errors.maxlength">
              El apellido debe tener máximo 200 caracteres
            </div>
          </div>

        </div>


        <div class="form-group">
          <label for="movil">Celular</label>
          <input formControlName="movil" name="movil" onkeypress='return event.charCode >= 48 && event.charCode <= 57' class="form-control input-sm" placeholder="0965452134" type="tel" required minlength="10" maxlength="10"><span class="bar"></span>

          <div class="alert-danger" *ngIf="movil.invalid && (movil.dirty || movil.touched)" >
            <div class="container-error-message" *ngIf="movil.errors.required" >
              El número de celular es requerido
            </div>
            <div class="container-error-message" *ngIf="movil.errors.minlength">
              El número de celular debe tener mínimo 10 caracteres
            </div>
            <div class="container-error-message" *ngIf="movil.errors.maxlength">
              El número de celular debe tener máximo 10 caracteres
            </div>
            <div class="container-error-message" *ngIf="movil.errors.pattern">
              El número de celular no es válido
            </div>
          </div>

        </div>


        <div class="form-group">
          <label for="correo">Correo Electrónico</label>
          <i><div style="font-size: 12px; padding: 0px; margin: 0px;">(Se enviará la contraseña a tu correo electrónico)</div></i>
          <input formControlName="correo" name="correo" class="form-control input-sm" type="email" required email minlength="5" maxlength="150">
          <span class="bar"></span>

          <div class="alert-danger" *ngIf="correo.invalid && (correo.dirty || correo.touched)" >
            <div class="container-error-message" *ngIf="correo.errors.required" >
              El correo es requerido
            </div>
            <div class="container-error-message" *ngIf="correo.errors.minlength">
              El correo debe tener mínimo 5 caracteres
            </div>
            <div class="container-error-message" *ngIf="correo.errors.maxlength">
              El correo debe tener máximo 150 caracteres
            </div>
            <div class="container-error-message" *ngIf="(correo.dirty || correo.touched) && correo.invalid && correo.errors.pattern">
              Debe ser un correo válido
            </div>
          </div>

        </div>

        <div class="row  mb-3">
          <div class="col-6">
            <div class="col-xs-6 "><label><b>Soy un...</b></label></div>
          </div>
          <div class="col-6">
            <select formControlName="rol" (change)="seleccionar($event)" class="form-control" required>
              <option selected value="SELECCIONAR">SELECCIONAR</option>
              <option value="ARRENDADOR">ARRENDADOR</option>
              <option value="ARRENDATARIO">ARRENDATARIO</option>
            </select>
          </div>

          <div class="alert-danger" *ngIf="rol.invalid && (rol.dirty || rol.touched)" >
            <div class="container-error-message" *ngIf="rol.errors.required" >
              El apellido es requerido
            </div>
          </div>
        </div>

        <div class="form-group text-center">
          <div class="col-xs-12">
            <button class="btn btn-info btn-lg btn-block text-uppercase waves-effect waves-light" [disabled]="!formularioRegistro.valid" type="submit">
              Crear cuenta
            </button>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 text-center">
            <p>
              ¿Ya tienes una cuenta?
            </p>
            <a routerLink="/login" class="text-info m-l-5"><b>Inicia Sesión</b></a>
          </div>
        </div>
      </form>
    </div>
  </div>
  <br>
<!-- ============================================================== -->
<!-- End Wrapper -->
</body>



<div class="footer-dark">
  <footer>
      <div class="container">
          <div class="row">
              <div class="col-md-5 item">
                  <h3>Enlaces útiles</h3>
                  <ul>
                    <li><a href="/#/login">Iniciar Sesión</a></li>
                    <li><a href="/#/enviarmensaje">Contáctanos</a></li>
                    <li><a href="/#/principal">Inicio</a></li>
                  </ul>
              </div>
              <div class="col-md-5 item">
                  <h3>Contacto</h3>
                  <ul>
                      <li><a href="#">Loja, Loja-Ecuador</a></li>
                      <li><a href="/#/enviarmensaje">Contáctanos</a></li>
                      <li><a href="#">0989994545</a></li>
                  </ul>
              </div>

              <div class="col item social"><a href="#"><i class="fa fa-facebook"></i></a>
                                           <a href="#"><i class="fa fa-youtube"></i></a>
                                           <a href="#"><i class="fa fa-instagram"></i></a>
                                           <a href="#"><i class="fa fa-google"></i></a></div>
          </div>
          <br>
          <p class="copyright">lojahouse.com © 2020</p>
      </div>
  </footer>
</div>
